<template>
  <div class="CompanyWelfareBar">
    <h2>告别传统版本，定制专属授权，尊享超值福利</h2>
    <div class="headline">
      咨询电话：021-38760461
      &nbsp;或&nbsp;
      <a :href="serviceLink" target="_blank">联系企业客服</a>
    </div>
  </div>
</template>

<script>
import {serviceLink} from "@/constant/CONFIG";

export default {
  name: "CompanyWelfareBar",
  data(){
    return{
      serviceLink
    }
  }
}
</script>

<style lang="scss" scoped>
.CompanyWelfareBar{
  @include BgImage(100%,180px,'introduce/company/WelfareBar/CompanyWelfareBar.jpg',1);
  text-align: center;

  h2{
    padding: 52px 0 12px;
    font-size: 28px;
    color: #F5D9C3;
    line-height: 37px;
    letter-spacing: 2px;
  }

  .headline{
    letter-spacing: 1px;
    font-size: 15px;
    color: #F5D9C3;
    line-height: 20px;
    a{
      color: #F5D9C3;
      text-decoration: underline;
      @include ElementHover(#F6CF97,'');
    }
  }

}
</style>
